import { render, staticRenderFns } from "./beforedetial.vue?vue&type=template&id=15b899b2&scoped=true&"
import script from "./beforedetial.vue?vue&type=script&lang=js&"
export * from "./beforedetial.vue?vue&type=script&lang=js&"
import style0 from "./beforedetial.vue?vue&type=style&index=0&id=15b899b2&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b899b2",
  null
  
)

export default component.exports